import { cva } from "class-variance-authority";

export const inputVariants = cva(
  [
    "text-shape-neutral-outlined-foreground-default file:text-shape-neutral-outlined-foreground-default placeholder:text-shape-neutral-outlined-foreground-muted bg-shape-neutral-outlined-background border-shape-neutral-outlined-border-emphasised flex h-9 w-full min-w-0 border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
    "focus-visible:ring-ring-default focus-visible:ring-[3px]",
    "aria-invalid:border-shape-critical-outlined-border-emphasised",
  ],
  {
    variants: {
      variant: {
        default: "rounded-md",
        pill: "rounded-full",
      },
      readOnly: {
        true: "bg-shape-neutral-outlined-background-readonly",
        false: "",
      },
    },
    defaultVariants: { variant: "default", readOnly: false },
  }
);
